import * as Sentry from "@sentry/vue";

export const captureException = function (error: any) {
  Sentry.captureException(error);
};
